import Vue from 'vue'
import { settings } from './variables.js'
import axios from 'axios'

import ContactForm from './vue_components/ContactForm.vue'
import QuestionForm from './vue_components/QuestionForm.vue'
import CallmeForm from './vue_components/CallmeForm.vue'
import CallmeFormInline from './vue_components/CallmeFormInline.vue'
import FaqForm from './vue_components/FaqForm.vue'
import SearchProduct from './vue_components/SearchProduct.vue'

import CartBlock from './vue_components/CartBlock.vue'
import AddToCartPopupBtn from './vue_components/AddToCartPopupBtn.vue'
import CartPage from './vue_components/CartPage.vue'
import CheckPage from './vue_components/CheckPage.vue'


Vue.config.productionTip = false
axios.defaults.baseURL = settings.apiBaseUrl
axios.defaults.withCredentials = true 
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"

Vue.prototype.$axios=axios


var vm = new Vue({
  el: '#app',
  components: {
  	'contactform': ContactForm,
    'questionform': QuestionForm,
    'callmeform': CallmeForm,
    'callmeforminline': CallmeFormInline,
    'faqform': FaqForm,
    'search-product': SearchProduct,
    'cart-block': CartBlock,
    'add-to-cart-popup': AddToCartPopupBtn,
    'cart-page': CartPage,
    'check-page': CheckPage
  },
  data: {}
})
